module.exports = __webpack_public_path__ + "media/packs/images/filter-9758b284a1054a5315d426414562af51.svg";